import React from 'react';
import '../CSS/Login.css';
import AmizoneLogo from '../Images/amizone-logo-inner.png';
import {InputAdornment, IconButton} from '@material-ui/core';
import ColorBorderedInput from '../Components/CustomComponents/ColorBorderedInput'
import {AccountCircle, Lock, Visibility, VisibilityOff} from '@material-ui/icons';
import {ClipLoader} from "react-spinners";
import {useHistory} from 'react-router-dom';
import { motion} from 'framer-motion';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';

function Login(props) {
  
  const [details, setDetails] = React.useState({
    userName : '',
    password : ''
  })

  const errorLines = {
    empty : "User-Name and Password fields are empty.",
    length : "Must be of length between 5 and 20.",
    wrong : "Wrong User-Name or Password! Check credentials.",
    amity : "Or else Amity University servers might have heavy traffic."
  }
  const history  = useHistory();

  const [loading, setLoading]  = React.useState(false);

  const [errorEmpty, setErrorEmpty] = React.useState(false);

  const [errorLength, setErrorLength] = React.useState(false);

  const [errorWrong, setErrorWrong] = React.useState(false);

  const [visible, setVisible] = React.useState({
    showPassword : false
  });

  const handleChange = (prop) => (event) => {
    setDetails({ ...details, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setVisible({ ...visible, showPassword: !visible.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  localStorage.setItem("loggedIn", false);
  localStorage.setItem("cookie","");
   localStorage.setItem("details", "");
                

  const validate = async ()=>{
    setLoading(true);
    var userLen = details.userName.length;
    var passLen = details.password.length;
    setErrorEmpty(false);
    setErrorLength(false);
    setErrorWrong(false);
    if(userLen===0||passLen===0){
      setErrorEmpty(true);
      setLoading(false);
    }else{
      setErrorEmpty(false);
      if((userLen<5||userLen>20)||(passLen<5||passLen>20)){
        setErrorLength(true);
        setLoading(false);
      }else{
        setErrorLength(false);
        const options = {
          method : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            userName: details.userName,
            password : details.password 
          })
        }
        fetch(getUrl() + 'login', options)
        .then(response => response.json()).then(
          async data =>{    
            if(data.retry===true){
              console.log("retrying...");
              validate();
            }else{
              if(data.check===false){
                setErrorWrong(true);
                setLoading(false);
              }else{
                fetch(getUrl() + 'login', options).then(response=>response.json()).then(
                  data=>{
                    if(data.retry===true){
                      validate();
                    }else{  
                      setLoading(false);
                      localStorage.setItem("loggedIn", true);
                      localStorage.setItem("cookie", data.cookies);
                      localStorage.setItem("details", JSON.stringify(details));
                      history.push("/home")
                    }
                  }
                )
              }
            }
          }
        );
        
      }
    }
  };
  

  return (
    <motion.div className="Login"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="ModaleLogin" >
        <img src={AmizoneLogo} alt="amizone" className="AmizoneLogoLogin" alt="Amizone"/>
        <div className="LoginTextLogin">
          LOGIN
        </div>
        <div className="FormLogin">
          <ColorBorderedInput
          id="userName"
          placeholder="User Name"
          className = "InputFieldLogin"
          onChange={handleChange('userName')}
          startAdornment={
            <InputAdornment position="start">
              <AccountCircle className="InputIcon"/>
            </InputAdornment>
          }/>
          
          <ColorBorderedInput
          id="password"
          className = "InputFieldLogin"
          type={visible.showPassword?"text":"password"}
          value={details.password}
          onChange={handleChange('password')}
          placeholder="Password"
          endAdornment={
            <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {visible.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
          }
          startAdornment={
            <InputAdornment position="start">
            <Lock className="InputIcon"/>
          </InputAdornment>
          }/>

          
          <button value="LOGIN" className="LoginButtonLogin" onClick={validate} >
            {(loading===true)? 
            <ClipLoader
              size={17}
              color={"rgb(10,78,149)"}/>:
              "LOGIN"
              }
            
          </button>
            
          
          <div className="ErrorLogin">{errorEmpty===true?errorLines.empty:""}</div>
          <div className="ErrorLogin">{errorLength===true?errorLines.length:""}</div>
          <div className="ErrorLogin">{errorWrong===true?errorLines.wrong:""}</div>
          <div className="ErrorLogin">{errorWrong===true?errorLines.amity:""}</div>
        </div>
      </div>
    </motion.div>
  );
}

export default Login;